import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';
import { fixedUi } from '@/i18n/fixedUi';
import TemplateKvDetailModal, { displayValue } from '@/tiktok-platform/modules/templates/TemplateKvDetailModal';
import { formatBeijingDateTime } from '@/tiktok-platform/utils/formatBeijingDateTime';

function availabilityText(row) {
  if (row?.isAvailable === true) return i18n.t('brandLib.available', { ns: 'workbench' });
  if (row?.isAvailable === false) return i18n.t('brandLib.unavailable', { ns: 'workbench' });
  return '';
}

/**
 * 运费模板详情（只读）：完整字段分段表格展示（对齐仓库模板详情）。
 * 数据取自本地同步缓存行（来源 Get Available Shipping Template），不再请求平台、不展示原始 JSON。
 */
export default function FreightTemplateDetailModal({
  open = false,
  row = null,
  onClose,
}) {
  const { t } = useTranslation('workbench');
  const sections = useMemo(() => {
    if (!row) return [];
    return [
      {
        key: 'basic',
        title: t('freightLib.basic'),
        rows: [
          {
            key: 'freightTemplateId',
            label: t('freightLib.colId'),
            value: displayValue(row.freightTemplateId || row.templateId || row.shippingTemplateId || row.id),
          },
          { key: 'name', label: t('freightLib.colName'), value: displayValue(row.name || row.templateName) },
          { key: 'templateParty', label: t('freightLib.colParty'), value: displayValue(fixedUi(row.templatePartyLabel || row.templateParty || '')) },
          { key: 'isDefault', label: t('freightLib.colDefault'), value: displayValue(row.isDefault === true ? t('returnDetail.yes') : (row.isDefault === false ? t('returnDetail.no') : '')) },
          { key: 'availability', label: t('freightLib.colAvailable'), value: displayValue(availabilityText(row)) },
          {
            key: 'synced',
            label: t('freightLib.colSynced'),
            value: displayValue(formatBeijingDateTime(row.lastSyncedAt || row.updatedAt)),
          },
        ],
      },
      {
        key: 'reason',
        title: t('freightLib.reasonTitle'),
        rows: [
          { key: 'description', label: t('freightLib.reason'), value: displayValue(row.description) },
          { key: 'hint', label: t('freightLib.hint'), value: t('freightLib.reasonHint') },
        ],
      },
    ];
  }, [row, t]);

  return (
    <TemplateKvDetailModal
      open={open && Boolean(row)}
      title={t('freightLib.detail')}
      subtitle={`${displayValue(fixedUi(row?.templatePartyLabel || row?.templateParty || ''))} · ${displayValue(row?.name || row?.templateName || row?.freightTemplateId)}`}
      sections={sections}
      onClose={onClose}
    />
  );
}
